import { render, staticRenderFns } from "./StartSieItem.vue?vue&type=template&id=5a0c1590&scoped=true&"
import script from "./StartSieItem.vue?vue&type=script&lang=ts&"
export * from "./StartSieItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c1590",
  null
  
)

export default component.exports